import { fetchFeeData } from '@wagmi/core';
import { estimateGasLimits } from '../estimateGaslimit';
import { MAX_PRIORITY_FEE_PER_GAS } from '../contants';

export async function estimateGasForConnectors(
	_smartContractWalletAddress: string,
	targetArray: Array<string>,
	callData: Array<string>,
	functionName: string
) {
	let gasLimit;
	gasLimit = await estimateGasLimits(
		_smartContractWalletAddress,
		targetArray,
		callData,
		functionName
	);
	return gasLimit;
}




export async function getMaxFeeAndPriorityFee() {
	const { gasPrice } = await fetchFeeData();
	const maxPriorityFeePerGas = BigInt(MAX_PRIORITY_FEE_PER_GAS)
	const maxFeePerGas = BigInt(gasPrice!) + maxPriorityFeePerGas;
	return {
		maxFeePerGas,
		maxPriorityFeePerGas
	}
} 